export default __webpack_public_path__ + "static/media/Penguin.6c26facc.png";